import { proxy } from 'valtio';
import { StepIndexerState } from 'hooks/useStepIndexer';

export const createHybridMeetingStepIndexer = proxy<StepIndexerState>({
  stepIndex: 0,
  previousStep: 0,
});
